import TabPage from "./../../factories/tab-page";
import "./../../factories/tab-controller";
import "./../../bindings/bao-tabs";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import * as $ from "jquery";
class BIReportModel {
    //Track the event listener to prevent it from being added multiple times
    static HasWindowResizeEventListener = false;
    Bao = Bao;
    TabPage: TabPage;
    BIReportUrl = ko.observable('');
    ReportLoaded = ko.observable(false);
    Parent;
    PaddingTop = ko.observable('185px'); //Default padding for one row of tabs
    TabsList: KnockoutObservableArray<TabPage>;
    TabActive: KnockoutObservable<boolean>;
    TabsListSubscription: KnockoutSubscription;
    TabsActiveSubscription: KnockoutSubscription;
    RecalculateDistanceToTop() {
        this.PaddingTop((89 + $(this.TabPage.$TabController.TabContainer()).height() + 60) + "px");
        //Using a class selector for BIReport iframe containers allows for multiple Report Center tabs being handled by one event handler
        $('.bireport-iframe-container').css('height', 'calc(100vh - ' + this.PaddingTop() + ')');
    }
    RecalculationEventHandler = () => {
        this.RecalculateDistanceToTop();
    };
    IsAvailableBIReport = ko.computed(() => {
        return Boolean(this.ReportLoaded() && this.BIReportUrl());
    });
    constructor(parent: any) {
        this.Parent = parent;
        this.TabPage = parent.TabPage;
        //Monkey patch for removing the resize event listener on tab close
        var formerDestroy = this.TabPage.destroy;
        this.TabPage.destroy = function destroy() {
            window.removeEventListener("resize", this.RecalculationEventHandler);
            BIReportModel.HasWindowResizeEventListener = false;
            //Remove subscriptions
            this.TabsListSubscription.dispose();
            this.TabsListSubscription = null;
            this.TabsActiveSubscription.dispose();
            this.TabsActiveSubscription = null;
            return formerDestroy();
        }.bind(this);
    }
    init() {
        this.TabPage.IsLoading(true);
        //Resize the window:
        //1. When adding and closing tabs (in case there are more/fewer tab rows than before)
        this.TabsList = this.TabPage.$TabController.Tabs;
        this.TabsListSubscription = this.TabsList.subscribe(function () {
            this.RecalculateDistanceToTop();
        }.bind(this));
        //2. When the user switches to the Report Center from another tab (in case other tabs' titles changed)
        this.TabActive = this.TabPage.IsActiveTab;
        this.TabsActiveSubscription = this.TabActive.subscribe(function () {
            this.RecalculateDistanceToTop();
        }.bind(this));
        this.getDataFromServer().then(result => {
            ko.map.fromJS(result, this);
            this.RecalculateDistanceToTop();
            this.ReportLoaded(true);
            this.TabPage.IsLoading(false);
        }).fail(() => {
            this.ReportLoaded(false);
            this.TabPage.IsLoading(false);
        });
    }
    loaded() {
        this.TabPage.IsLoading(false);
        //Check if the event listener exists
        if (!BIReportModel.HasWindowResizeEventListener) {
            window.addEventListener("resize", this.RecalculationEventHandler);
            BIReportModel.HasWindowResizeEventListener = true;
        }
    }
    private getDataFromServer() {
        return Bao.post("ReportCenter/BIGetReportModel");
    }
}
export default BIReportModel;